import { useQuery } from '@tanstack/react-query';

import { clientsService } from '../services';

import { clientsKeys } from './useClients';

export function useClientRedFlags(clientId: string | undefined) {
  return useQuery({
    queryKey: clientsKeys.operation('red-flags', clientId ?? ''),
    queryFn: () => {
      if (!clientId) throw new Error('missing id');
      return clientsService.listRedFlags(clientId);
    },
    enabled: Boolean(clientId),
  });
}
